import { UseBluetoothReturn, identity } from "@vueuse/core";
import {
  CHECKMEPRO_COMAND_DEVICEINFO,
  CHECKMEPRO_COMAND_ECG_FILE,
  CHECKMEPRO_COMAND_ECG_ITEM_FILE,
  CHECKMEPRO_COMAND_END,
  CHECKMEPRO_COMAND_PRESSURE_FILE,
  CHECKMEPRO_COMAND_PRESSURE_ITEM_FILE,
  CHECKMEPRO_COMAND_READDATA,
  CHECKMEPRO_COMAND_SPO2_FILE,
  CHECKMEPRO_COMAND_SPO2_ITEM_FILE,
  CHECKMEPRO_COMAND_STARTREAD,
  CHECKMEPRO_COMAND_TEMPERATURE_FILE,
  CHECKMEPRO_COMAND_TEMPERATURE_ITEM_FILE,
  CHECKMEPRO_CRC,
  CHECKMEPRO_HEADER,
  CHECKMEPRO_SERVICE_UUID,
} from "../BleContstants";
import { CheckMeProDevice } from "../model/checkmepro/CheckMeProDevice";
import { ECGItem, parseEcgItem } from "../model/checkmepro/ECGItem";
import {
  crc8,
  getDateTime,
  getEndReadPackage,
  getInfoPackage,
  getReadDataPackage,
  getReadStartPackage,
} from "./CheckMeProBlePackages";
import { Ref, reactive, ref } from "vue";
import { ECGInnerItem } from "../model/checkmepro/ECGInnerItem";
import { getFileName, safeWrite } from "./EshBleUtils";
import { CheckMeProUser, parseCheckMeProUser } from "../model/checkmepro/User";
import {
  PressureItem,
  parsePressureItem,
} from "../model/checkmepro/PressureItem";
import { TemperatureItem, parseTemperatureItem } from "../model/checkmepro/TemperatureItem";
import { SPO2Item, parseSPO2Items } from "../model/checkmepro/SPO2Item";

const chekMeProBLEInst = reactive({} as CheckMeProBleDevice);
const softWait = 300;
const longWait = 500;

const delay = (delayInms) => {
  return new Promise((resolve) => setTimeout(resolve, delayInms));
};

export class CheckMeProBleDevice {
  private static instance: CheckMeProBleDevice;

  ECGs: ECGItem[];
  Pressures: PressureItem[];
  SPO2Items: SPO2Item[];
  Users: CheckMeProUser[];
  Temperatures: TemperatureItem[];
  NotificationCharacteristic: BluetoothRemoteGATTCharacteristic;
  WriteCharacteristic: BluetoothRemoteGATTCharacteristic;
  LastCommand: number;
  Device: CheckMeProDevice;
  LAST_COMMAND: number;
  LAST_FILE_COMMAND: number;
  LAST_FILE_NAME: string;
  LAST_FILE_ITEM: {};
  flag: false;
  globalCheckMeProReceiveData: number[] = [];
  fileCheckMeProGlobalReceiveData: number[] = [];
  filesize: number;
  currentpkg: number;
  title: string = "CheckMe Pro";
  device: BluetoothDevice;
  progress: Ref<string>;

  private constructor() {}

  static getInstance() {
    if (this.instance) {
      return this.instance;
    }
    this.instance = new CheckMeProBleDevice();
    this.instance.progress = ref("");
    return this.instance;
  }

  async setupDevice(): Promise<void> {
    const server = await this.device.gatt.connect();
    const service = await server.getPrimaryService(CHECKMEPRO_SERVICE_UUID);
    const characteristics = await service.getCharacteristics();
    this.NotificationCharacteristic = characteristics[0];
    this.WriteCharacteristic = characteristics[1];
    this.NotificationCharacteristic.addEventListener(
      "characteristicvaluechanged",
      this.handleData
    );
    this.NotificationCharacteristic.startNotifications();
  }

  async infoDevice() {
    this.LAST_COMMAND = CHECKMEPRO_COMAND_DEVICEINFO;
    safeWrite ( this.WriteCharacteristic,getInfoPackage());
    while (this.LAST_COMMAND != 0) {
      await delay(softWait);
    }
  }

  async readUser() {
   while (this.LAST_COMMAND != 0) {
      await delay(softWait);
    }
    await delay(softWait);
    this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
    this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_ECG_FILE;
    safeWrite ( this.WriteCharacteristic, getReadStartPackage("usr.dat"));
    let iDelay = 0
    while (this.LAST_COMMAND != 0) {
      await delay(softWait);
      iDelay += 1;
      if (iDelay == 10 && this.fileCheckMeProGlobalReceiveData.length == 0)
      {
        break;
      }
    }
    this.Users = parseCheckMeProUser(this.fileCheckMeProGlobalReceiveData);
    this.fileCheckMeProGlobalReceiveData = [];
    this.resetValues();
  }

  async readEcg() {
   
    while (this.LAST_COMMAND != 0) {
      await delay(softWait);
    }
    await delay(softWait);
    this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
    this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_ECG_FILE;
    safeWrite ( this.WriteCharacteristic, getReadStartPackage("ecg.dat"));
    while (this.LAST_COMMAND != 0) {
      await delay(softWait);
    }
    
    this.ECGs = parseEcgItem(this.fileCheckMeProGlobalReceiveData);
    this.fileCheckMeProGlobalReceiveData = [];
    this.resetValues();
  }

  async readPressure() {
    await delay(softWait);
    if (   !this.Pressures)
      this.Pressures = [];
     while (this.LAST_COMMAND != 0) {
        await delay(softWait);
      }
      
    this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
    this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_PRESSURE_ITEM_FILE;

    for (let i = 0; i < this.Users.length; i++) {
      await delay(softWait);
      while (this.LAST_COMMAND != 0 && i > 0) {
        await delay(softWait);
      }
      safeWrite ( this.WriteCharacteristic, getReadStartPackage(i + "nibp.dat"));
      this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
      this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_PRESSURE_ITEM_FILE;
      let iDelay=0
      while (this.LAST_COMMAND != 0 ) {
        await delay(softWait);
        if (iDelay == 10 && this.fileCheckMeProGlobalReceiveData.length == 0)
        {
          this.LAST_COMMAND = 0;
        }
        iDelay +=1
      }
      if( this.fileCheckMeProGlobalReceiveData.length >= 8)
      {
      const pressuerItems = parsePressureItem(
        this.fileCheckMeProGlobalReceiveData,
        this.Users[i]
      )
      this.Pressures.push (...pressuerItems);
      }
      this.fileCheckMeProGlobalReceiveData = [];
      this.resetValues();
      await delay(softWait);
    }
  }

  async readTemperature() {
   
    while (this.LAST_COMMAND != 0) {
      await delay(softWait);
    }
    await delay(softWait);
    this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
    this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_ECG_FILE;
    safeWrite ( this.WriteCharacteristic, getReadStartPackage("temp.dat"));
    let iDelay=0
     
    while (this.LAST_COMMAND != 0 ) {
      await delay(softWait);
      if (iDelay == 10 && this.fileCheckMeProGlobalReceiveData.length == 0)
      {
        this.LAST_COMMAND = 0;
      }
      iDelay +=1
    }
    
    this.Temperatures= parseTemperatureItem(this.fileCheckMeProGlobalReceiveData);
    this.fileCheckMeProGlobalReceiveData = [];
    this.resetValues();
  }

  async readSpo2() {
   
    while (this.LAST_COMMAND != 0) {
      await delay(softWait);
    }
    await delay(softWait);
    this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
    this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_ECG_FILE;
    safeWrite ( this.WriteCharacteristic, getReadStartPackage("oxi.dat"));
    let iDelay=0
    while (this.LAST_COMMAND != 0) {
      await delay(softWait);
    }
    if (iDelay == 10 && this.fileCheckMeProGlobalReceiveData.length == 0)
    {
      this.LAST_COMMAND = 0;
    }
    iDelay +=1
    
    this.SPO2Items= parseSPO2Items(this.fileCheckMeProGlobalReceiveData);
    this.fileCheckMeProGlobalReceiveData = [];
    this.resetValues();
  }

  handleData(e) {
    const instance = CheckMeProBleDevice.getInstance();

    const t = e.target;
    const receivedData = new Int8Array(t.value.byteLength);
    if ( instance.LastCommand ==CHECKMEPRO_COMAND_END )
    {
      
      this.LAST_COMMAND = 0;
      instance.globalCheckMeProReceiveData = [];
      return;
    }

    if ( t.value.byteLength == 12 && t.value.getInt8(1)==1 )
    {
      if (t.value.getInt8(8) == 9)
       console.log("file non presente")
      this.LAST_COMMAND = 0;
      instance.globalCheckMeProReceiveData = [];
      return;
    }
  
    // loop through each byte
    for (let i = 0; i < t.value.byteLength; i++) {
      receivedData[i] = t.value.getInt8(i);
      instance.globalCheckMeProReceiveData.push(t.value.getInt8(i));
      const value = t.value.getInt8(i);
    }

    if (
      instance.globalCheckMeProReceiveData[
        instance.globalCheckMeProReceiveData.length - 1
      ] == crc8(instance.globalCheckMeProReceiveData)
    ) {
      console.log("read end");
      switch (instance.LAST_COMMAND) {
        case CHECKMEPRO_COMAND_DEVICEINFO:
          instance.parseDeviceInfo();

          break;
        case CHECKMEPRO_COMAND_STARTREAD:
          instance.parseStartRead();

          break;
        case CHECKMEPRO_COMAND_READDATA:
          instance.parseReadData();

          break;
        default:
          this.LAST_COMMAND = 0;
          break;
      }

      instance.globalCheckMeProReceiveData = [];
    }
  }

  parseDeviceInfo() {
    let returnString = "";
    for (let i = 7; i < this.globalCheckMeProReceiveData.length - 8; i++) {
      if (this.globalCheckMeProReceiveData[i] == 0) {
        continue;
      }
      returnString += String.fromCharCode(this.globalCheckMeProReceiveData[i]);
    }

    this.Device = JSON.parse(returnString);
    this.LAST_COMMAND = 0;
    this.fileCheckMeProGlobalReceiveData = [];
    console.log(returnString);
  }

  parseStartRead() {
    this.LAST_COMMAND = CHECKMEPRO_COMAND_READDATA;
    const buf = this.globalCheckMeProReceiveData;

    const fileSize =
      (buf[7] & 0xff) |
      ((buf[8] & 0xff) << 8) |
      ((buf[9] & 0xff) << 16) |
      ((buf[10] & 0xff) << 24);

    this.filesize = fileSize;

    this.WriteCharacteristic.writeValue(getReadDataPackage(0));
  }

  async resetValues() {
    this.WriteCharacteristic.writeValue(getEndReadPackage()).catch(() => {
      console.log("DOMException: GATT operation already in progress.");
      return Promise.resolve()
        .then(() => delay(softWait))
        .then(() => {
          this.WriteCharacteristic.writeValue(getEndReadPackage());
        });
    });

    this.LAST_COMMAND = CHECKMEPRO_COMAND_END;
    this.currentpkg = 0;
    this.LAST_FILE_COMMAND = 0;
    await  delay(softWait).then ( () =>  this.LAST_COMMAND = 0 ) 
     
 
    
  
  }

  parseReadData() {
    this.progress.value =
      this.fileCheckMeProGlobalReceiveData.length.toString() +
      "/ " +
      this.filesize +
      "(" +
      this.currentpkg +
      " )";
    console.log(this.progress.value);
  
    let bufferLength = 520;
    if (this.filesize < bufferLength) {
      bufferLength = this.filesize;
    }
    if (this.globalCheckMeProReceiveData[1] != 0 )
      {
       this.resetValues();
        return;
      }
      this.LAST_COMMAND = CHECKMEPRO_COMAND_READDATA;
      const pknumber = this.globalCheckMeProReceiveData[3];
      const buf = this.globalCheckMeProReceiveData;
  
    const pkg = this.filesize / (520 - 8);

    if (
      this.fileCheckMeProGlobalReceiveData.length >= this.filesize ||
      this.currentpkg > pkg + 25 ||
      this.globalCheckMeProReceiveData.length == 8 ||
      this.globalCheckMeProReceiveData.length == this.filesize + 8
    ) {
      for (let i = 7; i < this.globalCheckMeProReceiveData.length - 1; i++) {
        this.fileCheckMeProGlobalReceiveData.push(
          this.globalCheckMeProReceiveData[i]
        );
      }

      this.LAST_COMMAND = 0;

      return;
    }
    this.currentpkg += 1;

    for (let i = 7; i < this.globalCheckMeProReceiveData.length - 1; i++) {
      this.fileCheckMeProGlobalReceiveData.push(
        this.globalCheckMeProReceiveData[i]
      );
    }

    console.log(" pkc" + this.currentpkg);

    console.log(this.globalCheckMeProReceiveData.length);
    console.log(" pkc" + this.currentpkg);
    this.WriteCharacteristic.writeValue(
      getReadDataPackage(this.currentpkg)
    ).catch(() => {
      console.log("DOMException: GATT operation already in progress.");
      return Promise.resolve()
        .then(() => delay(500))
        .then(() => {
          this.WriteCharacteristic.writeValue(
            getReadDataPackage(this.currentpkg)
          );
        });
    });
  }



  async readEcgItem(item: ECGItem) {
    if (item.innerItem != null) return;
    this.LAST_COMMAND = CHECKMEPRO_COMAND_STARTREAD;
    this.LAST_FILE_COMMAND = CHECKMEPRO_COMAND_ECG_ITEM_FILE;
    this.WriteCharacteristic.writeValue(
      getReadStartPackage(getFileName(item.date))
    );
    this.LAST_FILE_NAME = getFileName(item.date);
    this.LAST_FILE_ITEM = item;
    while (this.LAST_COMMAND != 0) {
      await delay(softWait);
    }
  }

}
